import { ApprovalType } from "../constants/apporval-type-enum";
import { ApprovalSubType } from "../constants/preauth-request.enum";

export interface IPatientNotificationMessage extends INotificationMessage {
  patientNotificationId: string,
  beneficiaryId: string,
  descriptionEnglish: string,
  descriptionArabic: string,
}

export interface IProviderNotificationMessage extends INotificationMessage {
  providerNotificationId: string,
  providerId: string,
}

export interface IPayerNotificationMessage extends INotificationMessage {
  payerNotificationId: string,
  payerId: string,
}

interface INotificationMessage {
  titleEnglish: string,
  titleArabic: string,
  isRead: boolean,
  readDate: string,
  createdBy: string,
  createdDate: string,
  userId?: string,
  navigateToEntity?: boolean,
  description?: INotificationMessageDescription,
}

export interface INotificationMessageDescription {
  entityType: NotificationEntityType,
  descriptionEnglish: string,
  descriptionArabic: string,
  approvalType?: ApprovalType,
  approvalSubType?: ApprovalSubType,
  approvalRequestId?: string,
  approvalCommunicationId?: string,
  batchId?: string
}

export interface INotification {
  notification: IPatientNotificationMessage | IPayerNotificationMessage | IProviderNotificationMessage
  notificationType: NotificationType
}

export enum NotificationType {
  PatientNotification = 0,
  LogOut = 1,
  ProviderNotification = 2,
  PayerNotification = 3
}

export type NotificationUnion = IPatientNotificationMessage | IProviderNotificationMessage | IPayerNotificationMessage;

export enum NotificationEntityType {
  Adjudication = 1,
  ApprovalStatusChanged = 2,
  CommunicationAdded = 3,
  CommunicationReplied = 4,
  HighCostDecisionMade = 5,
  HighCostReviewRequested = 6,
  ApprovalAssignment = 7,
  BatchAssignment = 8
}